module.exports = __webpack_public_path__ + "static/logoOxford2-ffafd3dc581fc97d8f9c9349b24eb6a3.png";